import { MuiImage } from "@repo/ui";
import contactInfoCheckImage from "@repo/ui/assets/images/contact-info-check.png";
import { type FC } from "react";

export const ContactInfoCheck: FC = () => {
	return (
		<MuiImage
			src={contactInfoCheckImage}
			sx={{
				position: "absolute",
				zIndex: -1,
				right: "20px",
				top: "150px",
			}} />
	);
}
